import React from "react";
import { BrowserRouter } from "react-router-dom";

import { isEmpty } from "lodash";
import AnimatedRoutes from "./utils/AnimatedRoutes";

import { getCookie } from "./utils/cookieUtil";

function RoutesMain() {
  const isAuth = getCookie("re_token");
  const uri = location.pathname;

  // token 값에 따른 화면 분기 처리
  if (isEmpty(isAuth)) {
    if (uri !== "/") {
      uri !== "/privacy" && window.location.replace("/");
    }
  } else {
    if (uri === "/") {
      window.location.replace("/home");
    } else {
      // access Token cookie 만료시 화면 리로딩
      const token = getCookie("ac_token");
      const param = new URLSearchParams(location.search);

      if (isEmpty(token)) {
        if (!param.get("refrash")) {
          const timer = setTimeout(() => {
            window.location.replace(uri + "?refrash=0");
          }, 300);
          () => clearTimeout(timer);
        } else {
          const params = Number(param.get("refrash")) + 1;
          if (params < 6) {
            const timer = setTimeout(() => {
              window.location.replace(uri + "?refrash=" + String(params));
            }, 700);
            () => clearTimeout(timer);
          } else {
            alert("앱을 다시 켜주시기 바랍니다.");
          }
        }
      }
    }
  }

  return (
    <>
      <BrowserRouter>
        <AnimatedRoutes />
      </BrowserRouter>
    </>
  );
}

export default RoutesMain;
